import useFormik from '../../../hooks/useFormik';
import authService from '../../../store/auth/service';
import FormInputRow from '../../../components/Form/InputRow';
import FormInput from '../../../components/Form/Input';
import ActionRow from '../../../components/ActionRow';
import Loader from '../../../components/Loaders/Loader';
import useSearchParams from '../../../hooks/useSearchParams';
import { validationSchema } from './validationSchema';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';

import { LoginPage } from 'routes/paths';
import { CompanyLogo } from '../../../components/CompanyLogo';
import { ContentBox } from 'components/ContentBox';
import { CompanyContext } from '../../../index';
import ButtonWithArrowIcon from '../../../components/Buttons/ButtonWithArrowIcon';

import styles from './styles.module.scss';

export const ConfirmEmailPage = () => {
  const navigate = useNavigate();
  const company = useContext(CompanyContext);
  const accessToken = useSearchParams().accessToken;

  const [confirmEmail, { isLoading, status: confirmationStatus }] =
    authService.useConfirmEmailMutation();

  const { getFieldProps, getFieldErrorProp, handleSubmit } = useFormik({
    initialValues: {
      password: '',
    },
    validationSchema,
    onSubmit: (value) => {
      confirmEmail({ token: accessToken, password: value.password });
    },
  });

  useEffect(() => {
    if (confirmationStatus === 'fulfilled') {
      navigate(LoginPage);
    }
  }, [confirmationStatus]);

  return (
    <div className={styles.root}>
      <ContentBox className={styles.content}>
        <CompanyLogo src={company.logo} responsive={true} />
        <div className={styles.description}>Please enter your new password</div>
        <form onSubmit={handleSubmit} className={styles.form}>
          <FormInputRow
            className={styles.inputRow}
            required
            {...getFieldErrorProp('password')}
          >
            <FormInput
              {...getFieldProps('password')}
              type="password"
              autoComplete="password"
              placeholder={'Password'}
            />
          </FormInputRow>
          <ActionRow style="space-between">
            <ButtonWithArrowIcon type="submit" disabled={isLoading}>
              Submit
            </ButtonWithArrowIcon>
          </ActionRow>
          {isLoading && <Loader />}
        </form>
      </ContentBox>
    </div>
  );
};
